import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { timeStamp } from 'console';
import { CalendarFilter } from 'src/app/models/CalendarFilter';
import { Student } from 'src/app/models/CalendarModels';
import { ScheduleRow } from 'src/app/models/ScheduleRow';
import { Schedule_ep } from 'src/app/models/Schedule_ep';
import { StudentSchedule } from 'src/app/models/StudentSchedule';
import { CalendarService } from 'src/app/services/calendar.service';
import { DataService } from 'src/app/services/data.service';
import { StudentScheduleService } from 'src/app/services/student-schedule.service';
import { ScheduleListComponent } from '../../schedule-list/schedule-list.component';

@Component({
  selector: 'app-student-list',
  templateUrl: './student-list.component.html',
  styleUrls: ['./student-list.component.scss']
})
export class StudentListComponent implements OnInit {

  dataFilter: CalendarFilter = new CalendarFilter();
  // filteredList: Student[] = [];
  wideFilterRows: any[] = [];
  numberOfRows = 0;
  @Output() selectAllEmit = new EventEmitter<boolean>();

  sort(header: any, indx: number) {
    console.log("hedaer", header);
    header.sorted = header.sortFn(header.sorted);
    this.activeSortIndex = indx;
  }

  activeSortIndex: number = -1;
  headers: Array<any> = [
    {
      title: "כיתה",
      sorted: SortDirection.None,
      sortFn: (sorted) => {
        console.log("class", sorted)

        if (sorted == SortDirection.None) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Class.value > next.Class.value ? 1 : -1);
          return SortDirection.Up
        }
        if (sorted == SortDirection.Up) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Class.value < next.Class.value ? 1 : -1);
          return SortDirection.Down
        }
        if (sorted == SortDirection.Down) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name > next.Name ? 1 : -1);
          return SortDirection.None
        }
      }
    },
    {
      title: "מספר כיתה",
      sorted: SortDirection.None,
      sortFn: (sorted) => {
        console.log("code", sorted)

        if (sorted == SortDirection.None) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => !cur.ClassCode ? -1 : !next.ClassCode ? 1 : cur.ClassCode.value > next.ClassCode.value ? 1 : -1);
          return SortDirection.Up
        }
        if (sorted == SortDirection.Up) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => !cur.ClassCode ? 1 : !next.ClassCode ? -1 : cur.ClassCode.value > next.ClassCode.value ? -1 : 1);
          return SortDirection.Down
        }
        if (sorted == SortDirection.Down) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name > next.Name ? 1 : -1);
          return SortDirection.None
        }
      }
    },
    {
      title: "סוג תגבור",
      sorted: SortDirection.None,
      sortFn: (sorted) => {
        console.log("code", sorted)

        if (sorted == SortDirection.None) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => !cur.Classification ? -1 : !next.Classification ? 1 : cur.Classification.value > next.Classification.value ? 1 : -1);
          return SortDirection.Up
        }
        if (sorted == SortDirection.Up) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => !cur.Classification ? 1 : !next.Classification ? -1 : cur.Classification.value > next.Classification.value ? -1 : 1);
          return SortDirection.Down
        }
        if (sorted == SortDirection.Down) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name > next.Name ? 1 : -1);
          return SortDirection.None
        }
      }
    },
    {
      title: "עיר",
      sorted: SortDirection.None,
      sortFn: (sorted) => {
        console.log("name", sorted)

        if (sorted == SortDirection.None) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.City > next.City ? 1 : -1);
          return SortDirection.Up
        }
        if (sorted == SortDirection.Up) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.City < next.City ? 1 : -1);
          return SortDirection.Down
        }
        if (sorted == SortDirection.Down) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name > next.Name ? 1 : -1);
          return SortDirection.None
        }
      }
    }, {
      title: "מספר זהות",
      sorted: SortDirection.None,
      sortFn: (sorted) => {
        console.log("tz", sorted)
        if (sorted == SortDirection.None) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => parseInt(cur.IdentityNumber) > parseInt(next.IdentityNumber) ? 1 : -1);
          return SortDirection.Up
        }
        if (sorted == SortDirection.Up) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => parseInt(cur.IdentityNumber) < parseInt(next.IdentityNumber) ? 1 : -1);
          return SortDirection.Down
        }
        if (sorted == SortDirection.Down) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name > next.Name ? 1 : -1);
          return SortDirection.None
        }
      }
    },
    {
      title: "שם מלא",
      sorted: SortDirection.None,
      sortFn: (sorted) => {
        console.log("name", sorted)

        if (sorted == SortDirection.None) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name > next.Name ? 1 : -1);
          return SortDirection.Up
        }
        if (sorted == SortDirection.Up) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name < next.Name ? 1 : -1);
          return SortDirection.Down
        }
        if (sorted == SortDirection.Down) {
          this.calendarSvc.studentsListFiltered.sort((cur, next) => cur.Name > next.Name ? 1 : -1);
          return SortDirection.None
        }
      }
    }
  ]

  constructor(public calendarSvc: CalendarService, private studentCalendarSvc: StudentScheduleService, public dataService: DataService) {
    this.calendarSvc.studentsSubject.subscribe(() => {
      this.calendarSvc.studentsList.forEach(stdnt => { stdnt.Index = ++this.numberOfRows })
      this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsList;
      this.filterStudents(this.calendarSvc.dataFilter);
    });

    this.calendarSvc.filterSubject.subscribe((data: CalendarFilter) => this.filterStudents(data))
    this.calendarSvc.wideFilterSubject.subscribe((data: any[]) => this.filterStudentsWidely(data))
    this.calendarSvc.filterStudentsSubject.subscribe((data: any[]) => this.checkedStudentsById(data));

  }


  ngOnInit(): void {
  }

  setHasScheduleClass(student: Student) {
    if (this.calendarSvc.isNoonMode)
      return student.noonSchedule?.IsPrivate;
    else
      return student.MainSchedule?.IsPrivate
  }

  /**
   * Filter function. another same function at .\..\class-schedule-list\class-schedule-list.component.ts
   * @param dataFilter 
   * @returns 
   */

  filterStudents(dataFilter: CalendarFilter) {
    debugger;
    this.unSelectAll();
    this.dataFilter = dataFilter;
    this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsList.filter(x => x.Account == this.dataService.userModel.InstitutionNumber);
    if (dataFilter.clearFilter)
      return;
    else {
      this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsList;
      let filterByAfternoon = false;
      if (dataFilter.ClassesValues.length > 0) {
        if (dataFilter.ClassesValues.includes("צהרון"))//צהרון
        {
          filterByAfternoon = true;
        }
        else {
          this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsListFiltered.filter(stdnt => dataFilter.ClassesValues.includes(stdnt.Class.viewValue));
        }

      }
      if (dataFilter.ClassAndCode.length > 0) {
        this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsListFiltered.filter(row =>
          dataFilter.ClassAndCode.some(x => x.Class == row.Class.value &&
            (!x.ClassCode && !row.ClassCode || (row.ClassCode && x.ClassCode == row.ClassCode.value))));
      }
      if (dataFilter.ClassificationValues.length > 0) {
        this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsListFiltered.filter(stdnt => dataFilter.ClassificationValues.includes(stdnt.Classification?.viewValue))
      }
      if (dataFilter.Afternoon == 1 || filterByAfternoon) {//צהרון
        this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsListFiltered.filter(stdnt => stdnt.AfternoonIdentifier && stdnt.AfternoonIdentifier == this.dataService.userModel.InstitutionNumber);
      }
      else {
        //this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsListFiltered.filter(stdnt => !stdnt.Afternoon || stdnt.AfternoonIdentifier != this.dataService.userModel.InstitutionNumber);
      }
      if (dataFilter.Camp !="") {
        this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsListFiltered.filter(stdnt => stdnt.Camp?.some(x => dataFilter.Camp.includes(x.viewValue)))
      }
    }
  }

  filterStudentsWidely(scdls: any[]) {
    this.wideFilterRows = scdls;
    this.unSelectAll();
    if (scdls.length == 0) {
      this.filterStudents(this.dataFilter)
      return;
    }
    this.calendarSvc.studentsListFiltered = this.calendarSvc.studentsList.filter(stdnt => {
      for (let scdl of scdls) {
        if ((scdl.Class == "צהרון" && stdnt.AfternoonIdentifier == this.dataService.userModel.InstitutionNumber) ||
          (stdnt.Class.viewValue == scdl.Class &&
            (scdl.ClassCode == "" && !stdnt.ClassCode || scdl.ClassCode == stdnt.ClassCode?.viewValue) &&
            (scdl.Classification == "" || scdl.Classification == stdnt.Classification?.viewValue)&&
            (scdl.Camp == undefined || scdl.Camp =="" || stdnt.Camp?.some(x => x.viewValue == scdl.Camp))))
          return true;
      }
      return false;
    })
  }

  checkedStudentsById(data: any[]) {
    this.unSelectAll();
    if (!data || data.length == 0)
      this.filterStudents(this.dataFilter);
    else {
      this.calendarSvc.studentsListFiltered.forEach(s => {
        s._checked = data.includes(s.Id);
      });
      this.selectedRows = this.calendarSvc.studentsListFiltered.filter(x => x._checked);
      this.selectAllEmit.emit(this.allSelected);
      this.calendarSvc.studentSelected.next(this.selectedRows);
    }
  }

  public selectedRows: Array<Student> = new Array<Student>();
  public allSelected: boolean = false;
  onSelectRow(stdnt: Student) {

    if (stdnt._checked) {
      this.selectedRows.push(stdnt);
      if (this.selectedRows.length == this.calendarSvc.studentsListFiltered.length)
        this.allSelected = true;
    }
    else {
      let i: number;
      i = this.GetScheduleSelectedIndex(stdnt);
      this.selectedRows.splice(i, 1);
      this.allSelected = false;
    }

    this.selectAllEmit.emit(this.allSelected);
    this.calendarSvc.studentSelected.next(this.selectedRows);
    this.setIsNoonMode();
    if (this.calendarSvc.isNoonMode) {
      this.getScheduleForSelectedRows(stdnt.noonSchedule ? stdnt.noonSchedule : this.calendarSvc.noonAccountSchedule);
    } else {
      this.getScheduleForSelectedRows(stdnt.MainSchedule ? stdnt.MainSchedule : this.calendarSvc.accountSchedule);
    }
    // if (stdnt._checked) {
    //   this.calendarSvc.fillStudentSchedule(stdnt.MainSchedule);
    // }
    // else {
    //   this.calendarSvc.studentScheduleSelected.next(null);
    // }
  }

  GetScheduleSelectedIndex(stdnt: Student): number {
    return this.selectedRows.findIndex(s => s.Index == stdnt.Index); //לבדוק אם זה התנאי הנכון
  }

  selectAllRows() {
    // this.calendarSvc.countStudents(this.calendarSvc.classSchedulesList, this.calendarSvc.studentsList);
    if (this.allSelected) {
      this.calendarSvc.studentsListFiltered.forEach(row => {
        row._checked = false;
      });
      this.allSelected = false;
      this.selectedRows = [];
    }
    else {
      this.calendarSvc.studentsListFiltered.forEach(row => {
        row._checked = true;
      })
      this.allSelected = true;
      this.selectedRows = this.calendarSvc.studentsListFiltered.filter(x => true);
    }
    this.selectAllEmit.emit(this.allSelected);//enableUpdateAll שולח פרמטר לחופשה ומערכת שעות לתלמיד בערך 
    this.calendarSvc.studentSelected.next(this.selectedRows) //שולח את רשימת התלמידים שנבחרו לחופשה ולמערכת שעות לתלמיד
    // this.getScheduleForSelectedRows(null);
    this.setIsNoonMode();
    this.calendarSvc.fillStudentSchedule(this.allSelected ?
      this.calendarSvc.isNoonMode ? this.calendarSvc.noonAccountSchedule : this.calendarSvc.accountSchedule : null);//שולח את המערכת שעות הנבחרת לעדכון של תלמיד/מוסד/ריק
  }

  setIsNoonMode() {
    this.calendarSvc.isNoonMode = this.dataFilter.ClassesValues.includes("צהרון") || this.dataFilter.Afternoon == 1 || this.wideFilterRows.some(x => x.Class == "צהרון");
  }

  unSelectAll() {
    this.allSelected = true;
    this.selectAllRows();
  }

  getScheduleForSelectedRows(schedule) {
    if (this.selectedRows.length == 1) {
      this.calendarSvc.fillStudentSchedule(schedule);
      // let studentSchedule: Schedule_ep = null;
      // this.calendarSvc.request.ContactNeedsId = this.selectedRows[0].Id;
      // this.calendarSvc.GetStudentSpecificSchedule().then((res: string) => {
      //   debugger
      //   if (!this.dataService.IsError(res)) {
      //     var data = JSON.parse(res);
      //     studentSchedule = data;
      //     this.calendarSvc.fillStudentSchedule(studentSchedule ? studentSchedule : this.calendarSvc.accountSchedule);
      //   }
      // }).catch(error => {
      //   debugger;
      // })
    }
    else if (this.selectedRows.length == 0) {
      this.calendarSvc.fillStudentSchedule(new Schedule_ep());
    }
    else {
      this.calendarSvc.fillStudentSchedule(this.calendarSvc.accountSchedule);
    }
  }

  // sortStatus:Array<any> = [{
  //     sortUp:false
  //   },
  //   {
  //     sortUp:false
  //   },
  //   {
  //     sortUp:false
  //   },
  //   {
  //     sortUp:false
  //   }]

  // sortt(rowNumber: number){
  //   switch (rowNumber){
  //     case 0:{
  //       if(this.sortStatus[0].sortUp){
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.IdentityNumber > next.IdentityNumber?1:-1);
  //         this.sortStatus[0].sortUp = false;
  //       }
  //       else{
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.IdentityNumber < next.IdentityNumber?1:-1);
  //         this.sortStatus[0].sortUp = true;
  //       }
  //       break;
  //     }
  //     case 1:{
  //       if(this.sortStatus[1].sortUp){
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.Name > next.Name?1:-1);
  //         this.sortStatus[1].sortUp = false;
  //       }
  //       else{
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.Name < next.Name?1:-1);
  //         this.sortStatus[1].sortUp = true;
  //       }
  //       break;
  //     }
  //     case 2:{
  //       if(this.sortStatus[2].sortUp){
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.Class > next.Class?1:-1);
  //         this.sortStatus[2].sortUp = false;
  //       }
  //       else{
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.Class < next.Class?1:-1);
  //         this.sortStatus[2].sortUp = true;
  //       }
  //       break;
  //     } 
  //     case 3:{
  //       if(this.sortStatus[3].sortUp){
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.ClassCode > next.ClassCode?1:-1);
  //         this.sortStatus[3].sortUp = false;
  //       }
  //       else{
  //         this.calendarSvc.studentsListFiltered.sort((cur,next) => cur.ClassCode < next.ClassCode?1:-1);
  //         this.sortStatus[3].sortUp = true;
  //       }
  //       break;
  //     }
  //   }
  // }
}

enum SortDirection {
  Up = 0,
  Down = 1,
  None = 2
}

